import { MEDIA_TRAITS } from '../../../shared/media-types'
import './media-labels.component.less'

/**
 * The binding that names the owner of the labels, for each media type. The
 * namespace and the id field come from the shared traits, so this component and
 * the pages read one table.
 */
const OWNER_BINDINGS = Object.freeze([
  Object.freeze({ mediaType: 'serviceAnnouncement', binding: 'serviceAnnouncementId' }),
  Object.freeze({ mediaType: 'social', binding: 'socialMediaId' }),
  Object.freeze({ mediaType: 'file', binding: 'filemediaId' })
])

class MediaLabelsController {
  constructor ($scope, MediaLabelService, $log) {
    'ngInject'

    this._$scope = $scope
    this._log = $log

    this._MediaLabelService = MediaLabelService

    this.namespace = ''
    this.idAttribute = ''
    this.labelOwnerId = 0

    this.MediaLabels = []
  }

  $onInit () {
    const owner = OWNER_BINDINGS.find(one => this[one.binding])

    if (!owner) {
      throw new Error('Unknown label type')
    }

    this.namespace = MEDIA_TRAITS[owner.mediaType].labelNamespace
    this.idAttribute = MEDIA_TRAITS[owner.mediaType].labelIdField
    this.labelOwnerId = this[owner.binding]

    // Setup subscription of MediaLabels (invoked on subscribe)
    this._unsubscribe = this._MediaLabelService.subscribe(state => {
      // We have a subscription for every media, serviceannouncements, socialmediasources items.
      // AND will be called at init, when new/deleted label, and ad-hoc (pr media item)
      // state returns date like this below - array with all labels:

      // {"MediaLabels":[{"id":1,"name":"Saturday evening","color":"#7FDBFF","createdAt":"2023-03-18T15:03:03.000Z","updatedAt":"2023-04-18T17:55:02.000Z","filemedias":[{"id":5,"name":"jumbotron5sec1","createdAt":"2023-03-18T15:45:14.000Z","updatedAt":"2023-03-18T15:45:14.000Z"}],"serviceannouncements":[],"socialmediasources":[{"id":2,"type":"InstagramHashtag","filter":"rf50","lastUpdate":"2023-04-30T06:51:42.000Z","createdAt":"2023-03-18T15:00:09.000Z","updatedAt":"2023-04-30T08:56:54.000Z"}]},
      //
      // Find the MediaLabels for this Media
      // Returns a array of: { id: mediaLabel.id, name: mediaLabel.name, color: mediaLabel.color } into this.MediaLabels
      this.MediaLabels = state.MediaLabels.filter(mediaLabel =>
        Object.prototype.hasOwnProperty.call(mediaLabel, this.namespace) &&
        mediaLabel[this.namespace].some(item => item.id === this.labelOwnerId)
      ).map(mediaLabel => ({ id: mediaLabel.id, name: mediaLabel.name, color: mediaLabel.color }))
    })
    // this.getMediaLabels();
    // Setup subscription of MediaLabel relation changes
    this._relationChangeUuid = this._MediaLabelService
      .subscribeToLabelRelationChanges(this.namespace, relationInstance => {
        if (relationInstance[this.idAttribute] === this.labelOwnerId) {
          this.getMediaLabels()
        }
      })
  }

  $onDestroy () {
    this._unsubscribe()
    this._MediaLabelService.unsubscribeToLabelRelationChanges(this.namespace, this._relationChangeUuid)
  }

  getMediaLabels () {
    // Get MediaLabels for this Media instance
    return this._MediaLabelService
      .getLabels(this.namespace, this.labelOwnerId)
      .then(MediaLabels => {
        this.MediaLabels = MediaLabels
      })
  }

  removeLabel (labelId) {
    // Remove label from media
    return this._MediaLabelService
      .removeLabel(this.namespace, this.labelOwnerId, labelId)
  }
}

export default {
  bindings: {
    filemediaId: '<',
    serviceAnnouncementId: '<',
    socialMediaId: '<'
  },
  controller: MediaLabelsController,
  template: require('./media-labels.component.html').default
}
